<!-- 图片预览 -->
<template>
  <div class="imageViewer">
    <el-dialog
      class="img-preview"
      append-to-body
      :visible.sync="visible"
      width="80%"
      @opened="opened"
      @closed="$emit('closed')"
    >
      <span slot="title" class="dialog-footer">
        <el-form :disabled="false">
          <div class="dialog-title-button-group">
            <el-button
              @click="multiDownload"
              type="text"
              :title="$t('attach.downloadAll')"
            >
              <svg-icon icon-class="zip-download" style="margin-left: -3px" />
            </el-button>
            <el-button
              icon="el-icon-close"
              type="text"
              :title="$t('buttons.close')"
              @click="visible = false"
            ></el-button>
          </div>
        </el-form>
      </span>
      <swiper
        :options="swiperOptionTop"
        class="gallery-top swiper-no-swiping"
        ref="swiperTop"
      >
        <swiper-slide
          v-for="item in imgArr"
          :key="item.id"
          style="position: relative"
        >
          <viewer
            ref="imageViewer"
            :options="viewerOptions"
            v-if="imageReady && visible"
          >
            <img :src="item.src" style="display: none" />
          </viewer>
          <div
            class="swiper-lazy-preloader swiper-lazy-preloader-white"
            v-else
          ></div>
        </swiper-slide>
      </swiper>
      <swiper
        :options="swiperOptionThumbs"
        class="gallery-thumbs swiper-no-swiping"
        ref="swiperThumbs"
        @slideChange="slideChange"
      >
        <swiper-slide
          v-for="(item, index) in imgArr"
          :key="item.id"
          @click.native="goTo(index, item)"
        >
          <img :src="item.thumbnail || item.src" />
          <el-button
            v-if="previewType !== 'check' && !disabled"
            type="text"
            icon="el-icon-error"
            @click.stop.prevent="handleDelete(index)"
          ></el-button>
        </swiper-slide>
        <div
          class="swiper-button-next swiper-button-white"
          slot="button-next"
        ></div>
        <div
          class="swiper-button-prev swiper-button-white"
          slot="button-prev"
        ></div>
      </swiper>
    </el-dialog>
    <a ref="downloadObj"></a>
  </div>
</template>

<script>
import { component as Viewer } from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { downloadFile } from '@/api/largeFile.js'
import largeFile from '@/views/Report/ReportEditor/js/largeFile.js'
import Sortable from 'sortablejs'
import formatConverter from '@/views/Report/ReportEditor/js/formatConverter.js'
import cannotPreview from '@/assets/images/cannotPreview.svg'
export default {
  name: 'imageViewer',
  data() {
    return {
      viewerOptions: {
        className: 'imageViewer',
        inline: true,
        fullscreen: false,
        navbar: false,
        title: '',
        toolbar: {
          zoomIn: true,
          zoomOut: true,
          oneToOne: true,
          reset: true,
          prev: false,
          play: {
            show: false
          },
          next: false,
          rotateLeft: true,
          rotateRight: true,
          flipHorizontal: true,
          flipVertical: true
        }
      },
      handleRange: undefined,
      swiperTop: undefined,
      swiperThumbs: undefined,
      swiperOptionTop: {
        spaceBetween: 10,
        zoom: true
      },
      swiperOptionThumbs: {
        preventClicksPropagation: false,
        spaceBetween: 60,
        centeredSlides: true,
        slideToClickedSlide: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      sortable: undefined,
      imgArr: [],
      visible: false,
      loading: undefined,
      disabled: false,
      imageReady: false
    }
  },
  props: {
    previewType: {
      type: String,
      default: 'check'
    }
  },
  components: {
    swiper,
    swiperSlide,
    Viewer
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.swiperTop = this.$refs.swiperTop.swiper
          this.swiperThumbs = this.$refs.swiperThumbs.swiper
          this.swiperTop.controller.control = this.swiperThumbs
          this.swiperThumbs.controller.control = this.swiperTop
          this.swiperThumbs.slideTo(0)
        })
      }
    }
  },
  methods: {
    async getCurrentImg() {
      console.log(this.swiperThumbs.activeIndex)
      const index = this.swiperThumbs.activeIndex
      if (!this.imgArr[index].src) {
        this.imageReady = false
        this.$nextTick(async () => {
          var imageFile = await downloadFile(this.imgArr[index].id)
          if (imageFile.status >= 200 && imageFile.status < 300) {
            var fileObj = formatConverter.base64ToBlob(imageFile.data)
            if (fileObj.type.indexOf('image') < 0) {
              this.$set(this.imgArr[index], 'src', cannotPreview)
            } else {
              this.$set(this.imgArr[index], 'src', imageFile.data)
            }
          } else {
            this.$set(this.imgArr[index], 'src', cannotPreview)
          }
          this.imageReady = true
          console.error('imageReady true')
        })
      }
    },
    slideChange() {
      this.getCurrentImg()
    },
    handleDelete(index) {
      this.$confirm(this.$t('alert.delete'), this.$t('status.warning'), {
        confirmButtonText: this.$t('buttons.confirm'),
        cancelButtonText: this.$t('buttons.cancel'),
        type: 'warning'
      }).then(async () => {
        this.imgArr.splice(index, 1)
        this.$message({
          type: 'success',
          message: this.$t('alert.deleteSuccess')
        })
        if (!this.imgArr.length) {
          this.$emit('refreshView', this.handleRange, 1)
          this.visible = false
        } else {
          await this.getCurrentImg()
          this.$emit('refreshView', this.handleRange, 1)
        }
      }).catch(() => { })
    },
    goTo(index, item) {
      this.swiperThumbs.slideTo(index)
    },
    opened() {
      if (this.previewType !== 'check') {
        this.setSort()
      }
      // this.$nextTick(() => {
      //   this.$refs.imageViewer[0].$viewer.show()
      // })
    },
    // 拖拽排序
    setSort() {
      const el = document.querySelector('.gallery-thumbs .swiper-wrapper')
      this.sortable = Sortable.create(el, {
        ghostClass: 'sortable-ghost', // Class name for the drop placeholder,
        setData: function (dataTransfer) {
          dataTransfer.setData('Text', '')
        },
        onEnd: evt => {
          const targetRow = this.imgArr.splice(evt.oldIndex, 1)[0]
          this.imgArr.splice(evt.newIndex, 0, targetRow)
          this.swiperThumbs.slideTo(evt.newIndex)
          this.getCurrentImg()
        }
      })
    },
    getImage() {
      this.imgArr.forEach(async (i) => {
        var imageFile = await downloadFile(i.id)
        this.$set(i, 'src', imageFile.data)
      })
    },
    async previewAttach(arr, disabled, handleRange) {
      // [{id,name,thumbnail,src}]
      if (arr.length === 0) return
      this.handleRange = handleRange
      this.disabled = disabled
      this.imgArr = arr
      var fileObj
      console.log('first visible')
      const getImageArr = this.imgArr.filter(i => !i.src)
      if (getImageArr.length === 0) {
        if (this.loading) {
          this.loading.close()
        }
        this.visible = true
        console.error('visible true')
      } else {
        this.loading = this.$loading({
          lock: true,
          text: this.$t('attach.prepare')
        })
        for (var i = 0; i < getImageArr.length; i++) {
          var imageInfo = getImageArr[i]
          if (this.$parent.getStorageImage) {
            this.$set(imageInfo, 'thumbnail', this.$parent.getStorageImage(imageInfo.id))
            this.$set(imageInfo, 'src', this.$parent.getStorageImage(imageInfo.id))
          }
          if (!imageInfo.thumbnail) {
            var thumbnail = await downloadFile(imageInfo.id, undefined, 48)
            // this.$set(imageInfo, 'thumbnail', thumbnail.data)
            if (thumbnail.status >= 200 && thumbnail.status < 300) {
              fileObj = formatConverter.base64ToBlob(thumbnail.data)
              if (fileObj.type.indexOf('image') < 0) {
                this.$set(imageInfo, 'thumbnail', cannotPreview)
              } else {
                this.$set(imageInfo, 'thumbnail', thumbnail.data)
              }
            } else {
              this.$set(imageInfo, 'thumbnail', cannotPreview)
            }
          }
          console.log(i, imageInfo.src)
          if (!imageInfo.src && i === 0) {
            const firstImageInfo = getImageArr[0]
            this.imageReady = false
            this.$nextTick(async() => {
              var response = await downloadFile(firstImageInfo.id)
              if (response.status >= 200 && response.status < 300) {
                fileObj = formatConverter.base64ToBlob(response.data)
                if (fileObj.type.indexOf('image') < 0) {
                  this.$set(firstImageInfo, 'src', cannotPreview)
                } else {
                  this.$set(firstImageInfo, 'src', response.data)
                }
              } else {
                this.$set(firstImageInfo, 'src', cannotPreview)
              }
              this.imageReady = true
              this.loading.close()
              this.visible = true
            })
          } else {
            this.loading.close()
            this.visible = true
            if (imageInfo.src && i === 0) {
              this.imageReady = true
            }
          }
        }
      }
    },
    multiDownload() {
      // 开始下载
      var fileList = []
      this.imgArr.forEach(img => {
        fileList.push(img.id)
      })
      largeFile.owner = this
      largeFile.downloadFiles(fileList)
    }
  }
}
</script>

<style lang="scss">
.viewer-container.imageViewer {
  background-color: transparent;
  .viewer-fullscreen {
    display: none;
  }
}

.img-preview {
  overflow: hidden !important;
  .el-dialog {
    overflow: hidden !important;
    background: none;
    box-shadow: none;
    max-width: 100%;
    max-height: 100%;
    padding: 0;
    margin: 0;
  }
  .el-dialog__close {
    display: none;
  }
  .dialog-title-button-group {
    position: absolute;
    right: 0px;
    z-index: 1000;
    button {
      color: white;
      font-size: 32px;
      svg {
        height: 22px !important;
        width: 22px !important;
        margin-top: -8px;
      }
    }
  }
  .el-dialog__body {
    padding: 0 !important;
    max-height: unset !important;
  }
  .el-dialog__header {
    border-bottom: none !important;
    .el-dialog__headerbtn {
      cursor: pointer;
      height: 80px;
      overflow: hidden;
      position: absolute;
      right: -40px;
      top: -40px !important;
      width: 80px;
      .el-dialog__close {
        font-size: 30px;
        position: absolute;
        color: #fff;
        bottom: 15px;
        left: 15px;
      }
    }
  }
}
.gallery-top {
  height: 70vh !important;
  width: 100%;
}
.gallery-thumbs {
  height: 180px !important;
  padding-top: 20px;
  box-sizing: border-box;
  width: 100%;
  // margin-top: 30px;
  .swiper-wrapper {
    .swiper-slide {
      position: relative;
      transition: 0.2s;
      &:hover {
        transform: scale(1.2);
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.8);
      }
      // &:hover .el-button{
      //   display: block;
      // }
      img {
        width: 100%;
        height: 100%;
      }
      .el-button {
        // display: none;
        position: absolute;
        bottom: 80%;
        right: -9px;
        font-size: 24px;
        color: #666;
      }
    }
  }
}
.gallery-thumbs .swiper-slide {
  width: 144px;
  height: 144px;
  opacity: 0.4;
}
.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}
.viewer-container {
  .show-delete {
    .viewer-list li {
      position: relative;
      &::after {
        content: "1";
        position: absolute;
        top: 0;
        right: 0;
        width: 10px;
        height: 10px;
        background: rgba(0, 0, 0, 0.2);
      }
    }
  }
}
</style>
